import {BaseDao} from "./BaseDao";
import {ApiHelper} from "../apiHelper";
import {ConstantMan} from "../constantMan";
import { Observable } from 'rxjs';

export class AvsBroadcasterDao extends BaseDao {
  constructor(apiHelper: ApiHelper) {
    super(ConstantMan.API.RESOURCE.AVS_BROADCASTERS, apiHelper);
  }

  getAllForMedia(mediaId: number): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/get-by-media/' + mediaId;
    return this.apiHelper.get(url, null, null);
  }

  getAllForMarket(marketId: number): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/get-by-market/' + marketId;
    return this.apiHelper.get(url, null, null);
  }

  getAll(): Observable<any> {
    let url = this.apiHelper.getServiceName() + this.getResource() + '/get/customer';
    return this.apiHelper.get(url, null, null);
  }
}
